import React from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';

const VirtualAccount = ({ account, customerId }: any) => {
  return (
    <Card>
      <Card.Body className='p-md-5 p-sm-2 pb-0'>
        <div>
          <Card.Title>Virtual Account Details</Card.Title>
        </div>
        <Row>
          <Col md={12}>
            <Form.Group className='mb-3' controlId='va-name'>
              <Form.Label>Beneficiary Name</Form.Label>
              <Form.Control
                disabled
                type='text'
                value={account?.displayName || 'NA'}
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className='mb-3' controlId='va-account-no'>
              <Form.Label>Account Number</Form.Label>
              <Form.Control disabled type='text' value={`9EBL${customerId}`} />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className='mb-3' controlId='va-ifsc'>
              <Form.Label>IFSC Code</Form.Label>
              <Form.Control disabled type='text' value={'DBSS0IN0811'} />
            </Form.Group>
          </Col>
          <Col md={12}>
            <Form.Group className='mb-3' controlId='va-bank-name'>
              <Form.Label>Bank Name</Form.Label>
              <Form.Control
                disabled
                type='text'
                value={'DBS Bank India Limited'}
              />
            </Form.Group>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default VirtualAccount;
